import {getCookie} from './CookieUtil'

const CSRF_HEADER = "X-XSRF-TOKEN";
const CSRF_COOKIE = "XSRF-TOKEN";

export const getSecurityHeaders = () => {
    const result = {};
    const csrfValue = getCookie(CSRF_COOKIE);
    if (csrfValue && csrfValue.length > 0) {
        result[CSRF_HEADER] = csrfValue;
    }
    return result;
};